/*
 * @Description: '税务共享平台路由跳转;
 * @Author: 贾博宁
 * @Date: 2021 03.27
 *
*/

export default [
    {
        path: 'product8',
        component:resolve => require(['@/views/product8'], resolve),
        name: 'product8',
        meta: {
            nav: '税务共享平台'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/product8.js